type LogoProps = {
    className?: string;
    style?: React.CSSProperties;
};

export function LogoFullSolidThin({ style, className }: LogoProps) {
    return (
        <img
            src="/img/hero-logo.png"
            alt="Hero Creative Studio"
            className={className}
            style={{ maxWidth: '100%', height: 'auto', background: 'transparent', objectFit: 'contain', ...style }}
        />
    );
}

export function LogoFullSquareGreen({ style, className }: LogoProps) {
    return (
        <img
            src="/img/hero-logo.png"
            alt="Hero Creative Studio"
            className={className}
            style={{ maxWidth: '100%', height: 'auto', background: 'transparent', objectFit: 'contain', ...style }}
        />
    );
}

export function LogoSquareGreen({ style, className }: LogoProps) {
    return (
        <img
            src="/img/hero-logo.png"
            alt="Hero Creative"
            className={className}
            style={{ maxWidth: '100%', height: 'auto', background: 'transparent', objectFit: 'contain', ...style }}
        />
    );
}
